/**
 * The PNID Tool theme — raven-ui's appearance pinned to the product's green
 * brand. Every PNID Tool surface (workspace shell, plant assets, login, the
 * workspace access card) mounts this instead of configuring
 * RavenAppearanceProvider inline, so the hue/shade choice lives in one place.
 */
import type { ReactNode } from 'react';
import { RavenAppearanceProvider } from '@ravenappdev/raven-ui';
import '../../../node_modules/@ravenappdev/raven-ui/dist/raven-ui.css';
import '../../styles/raven-foundation.css';
import '../../styles/design-tokens/raven.tokens.css';
import '../../styles/frame.css';
import '../../styles/button-recipes.css';
import '../../styles/field-recipes.css';

export default function PnidToolTheme({ children }: { children: ReactNode }) {
  return (
    <RavenAppearanceProvider primaryHue="green" primaryShade={900} defaultMode="light">
      {children}
    </RavenAppearanceProvider>
  );
}
